<template>
    <v-alert
        class="customer-keine-daten mb-0 mt-3"
        :value="true"
        type="info"
    >
        Es liegen aktuell keine Daten vor.
    </v-alert>
</template>

<script>

export default {
    name: 'KeineDaten',
};

</script>

<style scoped lang="scss">
    @import "@/style/colors.scss";

    .customer-keine-daten.v-alert {
        color: $black;
        background-color: $white !important;
        border-width: 0 0 0 0;
    }
</style>
